module.exports = __webpack_public_path__ + "img/mimo_3.60f91e89.jpg";